export default {
	state: {
		documentosGerais: {}
	},
	getters: {
		"documentosGerais": state => state.documentosGerais
	},
	mutations: {
		setDocumentosGerais(state, payload) {
			state.documentosGerais = payload
		}
	},
	actions: {
		atualizarEstadoDocumentosGerais({ commit }, payload) {
			commit('setDocumentosGerais', payload)
		}
	}
};